export default "__VITE_ASSET__BhwVLTD___"